import { getContrastColor } from 'site/Renderer/components/Cockpit/utils/color'
import {
  DEFAULT_ROW_HEIGHT,
  GanttCategory,
  GanttRowDescriptor
} from './Gantt.utils'
import {
  SidebarCategoryColumn,
  SidebarCategoryGroup,
  SidebarRow,
  SidebarRowsColumn
} from './GanttChart.styles'

type GanttCategoriesProps = {
  categories: GanttCategory[]
  rowList: GanttRowDescriptor[]
}

const GanttCategories = ({ categories, rowList }: GanttCategoriesProps) => {
  const isRowStriped = (globalRowIndex: number) => globalRowIndex % 2 === 1

  return categories.map((category) => {
    const categoryRows = rowList.filter((row) => row.categoryId === category.id)
    const categoryRowCount = categoryRows.length
    const categoryBackgroundColor = category.backgroundColor ?? '#f8f9fb'

    return (
      <SidebarCategoryGroup
        key={category.id}
        $height={DEFAULT_ROW_HEIGHT * categoryRowCount}
        data-testid={`gantt-category-${category.id}`}
      >
        <SidebarCategoryColumn
          $backgroundColor={categoryBackgroundColor}
          $labelColor={getContrastColor(categoryBackgroundColor)}
        >
          {category.label}
        </SidebarCategoryColumn>
        <SidebarRowsColumn>
          {categoryRows.map((row) => {
            const globalRowIndex = row.globalRowIndex
            return (
              <SidebarRow
                key={`${category.id}-${row.rowIndex}`}
                $isStriped={isRowStriped(globalRowIndex)}
                $height={DEFAULT_ROW_HEIGHT}
                data-testid={`gantt-sidebar-row-${globalRowIndex}`}
              />
            )
          })}
        </SidebarRowsColumn>
      </SidebarCategoryGroup>
    )
  })
}

export default GanttCategories
